
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { DeliverySlipItem } from '@/services/deliverySlipService'
import { services } from '@/services/services'
import { Company } from '@/repositories/system/data'
import { repositories } from '@/repositories/system/repositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ListContentLayout from '@/views/layout/ListContentLayout.vue'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'
import ConfirmDeleteDraft from '@/views/system/ConfirmDeleteDraft.vue'

const service = services.deliverySlip
const companyRepository = repositories.company

export default defineComponent({
  components: {
    ConfirmDeleteDraft,
    DismissibleAlert,
    ListContentLayout
  },
  setup () {
    const requestError = ref<string | null>(null)
    const loading = ref<boolean>(false)
    const slips = ref<DeliverySlipItem[]>([])
    const route = useRoute()
    const company = ref<Company>({
      key: 'dummy',
      name: '',
      isAvailable: true
    })
    const deleteTarget = ref<DeliverySlipItem | null>(null)

    onMounted(async () => {
      loading.value = true
      const companyKey = route.params.companyKey as string
      await callApiWrapper(requestError, async () => {
        company.value = await companyRepository.get(companyKey)
        slips.value = await service.getList(companyKey)
      })
      loading.value = false
    })

    const deleteSlip = async (serialNo: number) => {
      loading.value = true
      const companyKey = route.params.companyKey as string
      await callApiWrapper(requestError, async () => {
        await service.deleteDraft(companyKey, serialNo)
        slips.value = await service.getList(companyKey)
        deleteTarget.value = null
      })
      loading.value = false
    }

    return {
      requestError,
      loading,
      company,
      slips,
      deleteTarget,
      deleteSlip
    }
  }
})
